import { layout as saleLine } from "./LayoutSaleLine";
import { layoutTimes } from "./LayoutOrderStatus";
import { getStorage } from "store/local";
import {
  DishIcon,
  GrillIcon,
  FoodDeliveryIcon,
  CustomerServicesIcon,
} from "components/Icons";
import tools from "tools/dates";

const today = tools.dateToday();
const STYLE_STATE_ICON = "w-6 h-6 fill-current";
const KINDS = [
  { id: "take_away", name: "take_away" },
  { id: "to_table", name: "to_table" },
  { id: "delivery", name: "delivery" },
];

const STATES = {
  commanded: {
    header: "bg-neutral-800",
    textHeader: "!text-neutral-100",
    card: "bg-neutral-50",
    lines: "bg-neutral-100",
    icon: <CustomerServicesIcon className={STYLE_STATE_ICON} />,
  },
  in_preparation: {
    header: "bg-amber-300",
    textHeader: "!text-amber-900",
    card: "bg-amber-50",
    lines: "bg-amber-100",
    icon: <GrillIcon className={STYLE_STATE_ICON} />,
  },
  served: {
    header: "bg-sky-300",
    textHeader: "!text-sky-800",
    card: "bg-sky-50",
    lines: "bg-sky-100",
    icon: <DishIcon className={STYLE_STATE_ICON} />,
  },
  dispatched: {
    header: "bg-green-300",
    textHeader: "!text-green-900",
    card: "bg-green-50",
    lines: "bg-green-100",
    icon: <FoodDeliveryIcon className={STYLE_STATE_ICON} />,
  },
};

function layout(config) {
  const searchTable = () => {
    const session = getStorage("ctxSession");
    return `[
      ('state', '=', 'available'),
      ('shop', '=', ${session.shop})
    ]`;
  };

  const getAddress = (record) => {
    if (record && record["party."]) {
      const party_id = record["party."].id;
      return [["party", "=", `${party_id}`]];
    }
  };

  const onChangeLines = (activeRecord, fieldValue) => {
    if (activeRecord.lines) {
      let total_amount = 0;
      for (let l of fieldValue.values()) {
        total_amount += l.amount;
      }
      activeRecord["total_amount"] = total_amount;
    }
    return activeRecord;
  };

  let ctxView = {
    model: "sale.sale",
    defaultView: "column",
    tags: {
      // state: stateColors,
      // order_status: stateColors,
    },
    states: STATES,
    activeSearch: true,
    limit: 100,
    form_action: ["edit"],
    table_action: ["view"],
    orderBy: [["pos_create_date", "ASC"]],
    domain: [],
    // domain: [["sale_date", "=", today]],
    fields: {
      number: {
        type: "char",
        readOnly: true,
        searchable: true,
      },

      table_assigned: {
        type: "many2one",
        model: "sale.shop.table",
        recSearch: searchTable,
        required: true,
        filter: true,
      },

      party: {
        type: "many2one",
        model: "party.party",
      },

      shipment_address: {
        type: "many2one",
        model: "party.address",
        recSearch: getAddress,
      },

      sale_date: {
        type: "date",
      },
      pos_create_date: {
        type: "datetime",
      },

      state: {
        type: "char",
        readOnly: true,
        translate: true,
      },

      order_status: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      kind: {
        type: "selection",
        readOnly: true,
        options: KINDS,
        filter: true,
      },
      shop: {
        type: "many2one",
        model: "sale.shop",
        readOnly: true,
      },

      order_status_time: {
        type: "many2one",
        model: "sale.order_status.time",
        attrs: ["created", "commanded"],
        layout: layoutTimes,
      },
      sale_device: {
        type: "many2one",
        model: "sale.device",
        // recSearch: () => [],
        required: true,
        readOnly: true,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        readOnly: true,
        filter: true,
      },
      lines: {
        type: "one2many",
        model: "sale.line",
        layout: saleLine(config),
        withChange: onChangeLines,
        required: true,
      },

      total_amount: { type: "numeric", readOnly: true },
      comment: { type: "text" },

      write_uid: {
        type: "many2one",
        model: "res.user",
      },
    },

    form: [
      { name: "table_assigned" },
      { name: "party" },
      { name: "shipment_address" },
      { name: "sale_date" },
      { name: "shop" },
    ],

    list: [
      { name: "number" },
      { name: "kind" },
      { name: "comment" },
      { name: "sale_date" },
      { name: "order_status" },
      { name: "total_amount" },
      { name: "party" },
      { name: "lines" },
      { name: "table_assigned" },
      { name: "order_status_time" },
      { name: "shop" },
      { name: "sale_device" },
      { name: "agent" },
      { name: "pos_create_date" },
    ],
  };

  return ctxView;
}

export { layout };
